export function propertyTypeSteps() {
	const TYPE_PAGE_MARKERS = {
		'Ein/Zweifamilienhaus': 'fields[angabe_zum_einfamilienhaus_',
		Eigentumswohnung: 'fields[angabe_zur_wohnung_',
		Mehrfamilienhaus: 'fields[angabe_zum_mehrfamilienhaus_',
		Gewerbeimmobilie: 'fields[angaben_zu_sonstiges_gewerbe_',
		Grundstück: 'fields[weitere_angaben_grundstueck',
	}

	const getPageType = (page) =>
		Object.keys(TYPE_PAGE_MARKERS).find((type) => page.querySelector(`[name^="${TYPE_PAGE_MARKERS[type]}"]`)) ?? null

	const isVisible = (el) => el.style.display !== 'none'

	document.querySelectorAll('.yn-form').forEach((form) => {
		const typeSelect = form.querySelector('[name="fields[general_art_der_immobilie]"]')
		if (!typeSelect) return

		const pages = Array.from(form.querySelectorAll('.yn-form-page'))
		const typePages = pages.filter(getPageType)
		if (!typePages.length) return

		const nextBtn = form.querySelector('.button-next')
		const prevBtn = form.querySelector('.button-prev')
		if (!nextBtn || !prevBtn) return

		const appliesToSelection = (pageType) => pageType === typeSelect.value
		const syncFieldState = () => {
			typePages.forEach((page) => {
				const disabled = !appliesToSelection(getPageType(page))
				page.querySelectorAll('[data-ynfield="true"]').forEach((field) => {
					field.disabled = disabled
				})
			})
		}
		syncFieldState()
		typeSelect.addEventListener('change', syncFieldState)

		let lastVisibleIndex = pages.findIndex(isVisible)
		const observer = new MutationObserver(() => {
			const currentIndex = pages.findIndex(isVisible)
			if (currentIndex === -1 || currentIndex === lastVisibleIndex) return

			const wentForward = currentIndex > lastVisibleIndex
			lastVisibleIndex = currentIndex

			const pageType = getPageType(pages[currentIndex])
			if (pageType && !appliesToSelection(pageType)) {
				;(wentForward ? nextBtn : prevBtn).click()
			}
		})

		pages.forEach((page) => observer.observe(page, { attributes: true, attributeFilter: ['style'] }))
	})
}
